import React, {useState, useEffect} from 'react';
import {Platform, TextInput,  View} from 'react-native'

import tw from '../../styles/tailwind';

import Text from './../Text';

import {Control, useController} from "react-hook-form";

interface InputProps{
  control: Control,
  name: string,
  style?: object,
  placeholder?: string,
  numberOfLines?: number,
  multiline?: boolean,
  uncontrolled?: boolean,
  rules?: object,
}

export default function Input(props: InputProps) {
  if (!props.uncontrolled)
    var {field, fieldState: {invalid, isTouched, isDirty, error}} = useController({
      control: props.control,
      defaultValue: '',
      name: props.name,
      rules: props.rules,
    })


  // En web el campo va con esquinas suaves (rounded-lg); en nativo se mantiene
  // la píldora (rounded-full).
  const radius = Platform.OS === 'web' ? 'rounded-lg' : 'rounded-full'

  return (
    <>
      <View style={tw.style(`mb-5`, props.style?.container)}>
        <View style={tw.style(
          `bg-gray-100 w-full ${radius}`,
          // {borderColor: theme.COMPONENTS_BORDER_COLOR},
          invalid ? {borderColor: '#f44', borderWidth: 1} : {}, props.style?.subcontainer
        )}>
          
          {
            props.label && 
            <Text style={tw.style(`absolute bg-primary ml-3 px-2`, { marginTop: -22, fontWeight: 'bold'}), props.style?.label}>{props.label}</Text>
          }

          <TextInput
            value={!props.uncontrolled ? field.value : props.value}
            onChangeText={!props.uncontrolled ? field.onChange : null}
            onBlur={!props.uncontrolled ? field.onBlur : props.onBlur}
            ref={!props.uncontrolled ? field.ref : null}
            placeholderTextColor={tw.color(`gray-400`)}
            {...props}
            style={tw.style(`px-6 font-bold ${radius}`, props.multiline ? `py-3` : `h-12`, !props.multiline && { textAlignVertical: 'center' }, props.style?.input)}
          />
        </View>

        { !!error?.message && <Text style={tw.style(`mt-2`,)}>{error.message}</Text> }
      </View>
    </>
  )
}